import * as React from "react";

const LayoutWrapperContext = React.createContext({});

export const LayoutWrapperProvider = LayoutWrapperContext.Provider;

export const useLayoutWrapper = () => React.useContext(LayoutWrapperContext);
